import { EntraGroup } from './useEntraGroups';
import { FieldValidation } from '@rjsf/utils';

export const validateEntraGroup = (group: EntraGroup | undefined, validation: FieldValidation) => {
  if (group === undefined) return;
  if (!group?.id || !group?.displayName) {
    validation.addError('Please select a valid Entra group');
  }
};
